<template>
  <div
    id="designsSection"
    class="category-lists"
  >
    <h2
      class="p-8"
      v-if="categoryType === 'between'"
    >
      {{ $tv('designs', 'categories') }}
    </h2>
    <div
      v-for="(categoryGroup) in groupedCategories"
      :key="categoryGroup.brandName"
      :class="['category-list', 'p-8', categoryType === 'between' ? 'between' : '']"
    >
      <h3
        v-if="categoryGroup.brandName && !isAllCategories && grouped"
      >
        <span>{{ $tv(categoryGroup.brandName.substring(0, 1).toUpperCase(), 'brands') }}</span>
        <InfoIcon
          popup-ref="showBrandsPopup"
        />
      </h3>
      <h3
        v-if="categoryGroup.brandName && isAllCategories && grouped"
      >
        <span>{{ $tv(categoryGroup.brandName.substring(0, 1).toUpperCase(), 'brands') }}</span>
        <InfoIcon
          popup-ref="showBrandsPopup"
        />
      </h3>
      <div
        class="category-list__tiles"
      >
        <CategoryTileNew
          v-for="(category) in categoryGroup.categories"
          :key="parentId + '_' + categoryGroup.brandName + '_' + (category.technicalName || category.id || category.name)"
          :category="category"
          :path="path"
          :lazy="lazy"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CategoryTileNew from '~/components/category/CategoryTileNew'
import InfoIcon from '~/components/InfoIcon.vue'

let i = 0
export default {
  components: {
    CategoryTileNew,
    InfoIcon
  },
  props: {
    categories: {
      type: [Array, Object],
      default () {
        return []
      }
    },
    path: {
      type: String,
      default () {
        return null
      }
    },
    categoryType: {
      type: String,
      default() {
        return null
      }
    },
    parentId: {
      type: Number,
      default() {
        return i++
      }
    },
    lazy: {
      type: Boolean,
      default() {
        return false
      }
    },
    isAllCategories: {
      type: Boolean,
      default() {
        return false
      }
    },
    grouped: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  computed: {
    groupedCategories: function () {
      if (Array.isArray(this.categories) && this.grouped) {
        // Group categories by their brands
        const brandGroups = {}
        this.categories.forEach(category => {
          if (category.brands && Array.isArray(category.brands)) {
            category.brands.forEach(brand => {
              if (!brandGroups[brand]) {
                brandGroups[brand] = []
              }
              brandGroups[brand].push(category)
            })
          }
        })
        // Sort each brand's categories and order brands
        const sortedCategories = []

        // Custom brand order: freudenberg, dichtomatik, then rest alphabetically
        const allBrands = Object.keys(brandGroups)
        const restBrands = allBrands.filter(b => b !== 'freudenberg' && b !== 'dichtomatik').sort()
        const customOrder = []
        if (allBrands.includes('freudenberg')) {
          customOrder.push('freudenberg')
        }
        if (allBrands.includes('dichtomatik')) {
          customOrder.push('dichtomatik')
        }
        customOrder.push(...restBrands)

        customOrder.forEach(brand => {
          if (brandGroups[brand] && Array.isArray(brandGroups[brand])) {
            sortedCategories.push({
              brandName: brand,
              categories: [...brandGroups[brand]]
            })
          }
        })
        return sortedCategories
      } else if (Array.isArray(this.categories) && !this.grouped) {
        // Return categories as is when not grouped
        return [{categories: this.categories}]
      }
      return []
    }
  }
}
</script>
<style lang="scss">
.category-lists {
  background-color: $color__content--background__secondary;

  h2 {
    margin: 0;
    padding-block: .5rem;
  }

  @include breakpoint-down($md) {
    h2 {
      padding-top: $default-margin-padding-width * 1.5;
    }
  }
}

.category-list {
  display: flex;
  flex-flow: column wrap;

  + .category-list {
    padding-top: 0;
  }

  &.between {
    padding-top: 0;
  }

  h3{
    display: flex;
    gap: .5rem;
    line-height: 1.625rem;

    &:first-child {
      margin-top: 0;
      margin-bottom: 0;
      padding: .5rem 0;
    }
  }

  &__tiles {
    $gap: 1.25rem;

    display: inline-flex;
    flex-wrap: wrap;
    width: calc(100% + #{$gap});
    gap: $gap;

    @include breakpoint-down($md) {
      $gap: .563rem;

      gap: .75rem;
      width: calc(100% + #{$gap});
      padding-bottom: $default-margin-padding-1_5x;
    }
  }
}
</style>
